Boolean.prototype.yn = function() {
  return Number(this) ? 'Y' : 'N'
}
